/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const AlertsOff = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M17 18L21.0919 22.0919L22.1525 21.0312L3.06066 1.93934L2 3L6.25721 7.25721C6.08997 7.80882 6 8.394 6 9.00001L6.00004 11.8027C4.19392 12.8484 3 14.813 3 17.25V18H17ZM15.5 16.5L7.52476 8.52476C7.50839 8.68091 7.5 8.83946 7.5 8.99999L7.50005 12.729L7.07195 12.9324C5.75631 13.5576 4.77428 14.8135 4.54899 16.5H15.5Z"
                        fill={color}
                    />
                    <path
                        d="M11.25 3.04647C9.92278 3.21213 8.72963 3.81152 7.81845 4.69713L8.87925 5.75793C9.68902 4.97822 10.788 4.5 12 4.5C13.2428 4.5 14.3668 5.00286 15.182 5.81802C15.9971 6.63317 16.5 7.75739 16.5 9.00051L16.5013 12.7295L16.929 12.9329C18.1502 13.5135 19.0998 14.8162 19.4001 16.2788L21 17.8787V17.25C21 15.0623 19.8196 12.8893 18.001 11.8068L18 9C17.9999 7.34322 17.3276 5.84228 16.2426 4.75736C15.324 3.83872 14.1071 3.21586 12.75 3.04647V1H11.25V3.04647Z"
                        fill={color}
                    />
                    <path
                        d="M13.5 20V19.5H15V20C15 20.8282 14.6634 21.5792 14.1213 22.1213C13.5792 22.6634 12.8282 23 12 23C11.1718 23 10.4208 22.6634 9.87868 22.1213C9.33661 21.5792 9 20.8282 9 20V19.5H10.5V20C10.5 20.4144 10.6671 20.7884 10.9393 21.0607C11.2116 21.3329 11.5856 21.5 12 21.5C12.4144 21.5 12.7884 21.3329 13.0607 21.0607C13.3329 20.7884 13.5 20.4144 13.5 20Z"
                        fill={color}
                    />
                </svg>
        );
    };
